export const NOTIFICATION_TYPE = {
	success: 'success',
	error: 'error',
	info: 'info',
	warn: 'warn',
};
